import { TFunction } from "i18next";
import { TChipProps } from "components/shared/Chip";
import { HAQEffectiveStatus } from "utils/constants/HAQ.constants";
import { getDisplayedAssetStatus } from "../getDisplayedStatus";

const SPONSOR_STATUS_TRANSLATION_KEYS: Partial<
  Record<HAQEffectiveStatus, string>
> = {
  [HAQEffectiveStatus.AwaitingResponse]: "status.asset.RESPONSE_NEEDED",
  [HAQEffectiveStatus.Submitted]: "status.asset.RESPONSE_SUBMITTED",
};

export const getHAQEffectiveStatusLabel = (
  effectiveStatus: HAQEffectiveStatus | undefined,
  t: TFunction,
  isSponsor = false,
) => {
  const sponsorTranslationKey = effectiveStatus
    ? SPONSOR_STATUS_TRANSLATION_KEYS[effectiveStatus]
    : undefined;

  return isSponsor && sponsorTranslationKey
    ? t(sponsorTranslationKey, { ns: "common" })
    : getDisplayedAssetStatus(effectiveStatus, t);
};

export const getHAQEffectiveStatusChipConfig = (
  effectiveStatus: HAQEffectiveStatus | undefined,
  t: TFunction,
  isSponsor = false,
): TChipProps => {
  const label = getHAQEffectiveStatusLabel(effectiveStatus, t, isSponsor);

  switch (effectiveStatus) {
    case HAQEffectiveStatus.AvailableToSubmit:
      return { label, color: "info" };

    case HAQEffectiveStatus.AwaitingResponse:
      return { label, color: isSponsor ? "info" : "warning" };

    // applicable for HA only
    case HAQEffectiveStatus.ResponseReceived:
      return { label, color: "success" };

    // applicable for Sponsor only
    case HAQEffectiveStatus.Submitted:
      return { label, color: "success" };

    // applicable for HA only
    case HAQEffectiveStatus.Completed:
      return { label, color: "default" };

    default:
      return { label };
  }
};
